import React from "react";

import {Box} from "@material-ui/core";
import {useMiscellaneousStyles} from "../../styles/miscellaneous";
import useTheme from "@material-ui/core/styles/useTheme";

export default function GenericLogoLabel(props) {
    const classes = useMiscellaneousStyles();
    const {text, logo, justify, link} = props
    const theme = useTheme();

    return <Box
        display="flex"
        flexDirection="row"
        justifyContent={justify ? justify : 'flex-start'}
        alignItems="center"
        style={{color: 'inherit' , lineHeight: "150%"}}
    >
        <span style={{opacity:0.7}}>
            {text}
        </span>
        {link ?
            <a href={link} target="_blank" rel="noreferrer">
                <img alt="logo" className={classes.verifiedLogo} src={logo}/>
            </a> : <img alt="logo" className={classes.verifiedLogo} src={logo}/>}

    </Box>
}
